// Recuerda la categoría seleccionada por evento mientras dura la pestaña del navegador, para que al pasar
// entre Puntaje, Clasificación y Lanzamiento no se vuelva siempre a la primera categoría.

const storageKey = (scopeId: string) => `cccd-active-category:${scopeId}`

/** Id de la categoría guardada para ese evento, si todavía existe en `categories`; si no, la primera. */
export function readActiveCategoryId(scopeId: string | null | undefined, categories: { id: string }[]): string {
  if (scopeId) {
    try {
      const stored = sessionStorage.getItem(storageKey(scopeId))
      if (stored && categories.some((c) => c.id === stored)) return stored
    } catch {
      // Sin almacenamiento: se usa la primera categoría.
    }
  }
  return categories[0]?.id ?? ""
}

export function rememberActiveCategoryId(scopeId: string | null | undefined, categoryId: string): void {
  if (!scopeId || !categoryId) return
  try {
    sessionStorage.setItem(storageKey(scopeId), categoryId)
  } catch {
    // Sin almacenamiento: la selección vive solo en pantalla.
  }
}
